// extracted by mini-css-extract-plugin
export default {"root":"AddEditQuestionDialog_root__UazUr","dialogContent":"AddEditQuestionDialog_dialogContent__wbBg2"};